import { render, staticRenderFns } from "./AmountInput.vue?vue&type=template&id=9b968d32&scoped=true&"
import script from "./AmountInput.vue?vue&type=script&lang=js&"
export * from "./AmountInput.vue?vue&type=script&lang=js&"
import style0 from "./AmountInput.vue?vue&type=style&index=0&id=9b968d32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b968d32",
  null
  
)

export default component.exports